const uuid=/^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i;
export type CalendarActivityTarget={date:string;activityId:string};
export function validCalendarDay(day:unknown):day is string{
 if(typeof day!=='string'||!/^\d{4}-\d{2}-\d{2}$/.test(day))return false;
 const [y,m,d]=day.split('-').map(Number),v=new Date(Date.UTC(y,m-1,d));
 return y>=1900&&y<=2200&&v.getUTCFullYear()===y&&v.getUTCMonth()===m-1&&v.getUTCDate()===d;
}
export function activityCalendarDay(value:unknown):string|null{
 if(typeof value!=='string'||!validCalendarDay(value.slice(0,10))||!/^\d{4}-\d{2}-\d{2}T(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d{1,6})?)?(?:Z|[+-](?:0\d|1[0-4]):[0-5]\d)$/.test(value))return null;
 const time=new Date(value);if(!Number.isFinite(time.getTime()))return null;
 const parts=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Rome',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(time);
 const part=(type:string)=>parts.find(p=>p.type===type)?.value;
 const day=part('year')+'-'+part('month')+'-'+part('day');return validCalendarDay(day)?day:null;
}
export function parseCalendarActivityTarget(search:string):CalendarActivityTarget|null{
 const p=new URLSearchParams(search);if(p.getAll('fluDate').length!==1||p.getAll('fluActivity').length!==1)return null;
 const date=p.get('fluDate'),activityId=p.get('fluActivity');
 return validCalendarDay(date)&&typeof activityId==='string'&&uuid.test(activityId)?{date,activityId}:null;
}
export function calendarTargetDate(target:CalendarActivityTarget):Date{
 const [y,m,d]=target.date.split('-').map(Number);return new Date(y,m-1,d,12);
}
export function calendarActivityPath(target:CalendarActivityTarget):string|null{
 return validCalendarDay(target.date)&&uuid.test(target.activityId)?'/calendar?fluDate='+target.date+'&fluActivity='+target.activityId:null;
}
